import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedLandingPageService {

  constructor(private _apiService: ApiService) { }

  getBrowsedMaterial() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.BROWSED_MATERIAL}`
    return this._apiService.get(url);
  }

  getPendingGifts() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PENDING_GIFTS}`
    return this._apiService.get(url);
  }

  getEditorsChoice() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.EDITORS_CHOICE}`
    return this._apiService.get(url);
  }

  getSuggestedContent() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.SUGGESTED_CONTENTS}`
    return this._apiService.get(url);
  }

  getSuggestedContentAll() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.SUGGESTED_CONTENTS}?limit=all`
    return this._apiService.get(url);
  }

  fetchSuggestedConnectionsAll() {
    return this._apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + API_ENDPOINTS.API.SUGGESTED_CONNECTIONS + '?limit=all');
  }

  getTrendingContent() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.TRENDING_CONTENTS}`
    return this._apiService.get(url);
  }
  getTrendingContentAll(params?) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.TRENDING_CONTENTS}?limit=all`
    return this._apiService.get(url,params);
  }

  getMarketplaceContent(){
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.MARKETPLACE_CONTENT}`
    return this._apiService.get(url);
  }

  convertToken(currency) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CURRENCY_CONVERTER}${API_ENDPOINTS.API.CONVERT}?currency_type=USD&amount=${currency}`
    return this._apiService.get(url);
  }

  // do not delete without asking.
  trendingContent = {
    "success": true,
    "message": "",
    "data": {
        "music": [
            {
                "id": 4,
                "user_id": 1,
                "out_line": "Sample Data4",
                "description": "Sample date 4",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/e2a7a2de-45c0-4e8a-940e-1022895e018d.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=ed237dcf707f2e60b6de53f910276c0f07074c5d6d1440deb5b90b07d007318a",
                "audio_book": "",
                "adult_content": false,
                "content_type": "audio",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBFUT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--532fb19e3ed87edeadbba0c5bc3971ec40abf4a0/2.png?disposition=attachment",
                "created_at": "2020-02-27T14:44:26.480Z",
                "expiry_date": "2520-02-27T14:44:26.471Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T14:58:57.520Z",
                "duration": "1 month",
                "material": {
                    "material_id": 17,
                    "material_text": "Classical"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T14:44:28.304Z",
                "duration_number": 1,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 5,
                "user_id": 1,
                "out_line": "Sample Data 5",
                "description": "Sample Data 5",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/83038dcf-df00-4505-9a08-70744ffd37c2.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=7ef5321514a8d8a00d520f0302e9fde035886e2c1f72f20ff0d81488aa752e98",
                "audio_book": "",
                "adult_content": false,
                "content_type": "audio",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBFdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--27262995df9b20ceefb999bd157b883f5147a4a9/5.png?disposition=attachment",
                "created_at": "2020-02-27T14:49:46.252Z",
                "expiry_date": "2520-02-27T14:49:46.243Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T14:58:17.548Z",
                "duration": "5 months",
                "material": {
                    "material_id": 18,
                    "material_text": "Comedy"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T14:49:47.788Z",
                "duration_number": 5,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 13,
                "user_id": 6,
                "out_line": "Sample  Data13",
                "description": "Sample  Data13",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/3fd9cc6f-e9ff-49e9-8898-82d6e6992eae.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=eab04f73057ac80730a5ff59d50478628000592a81afdbbe131504bc0eeaa470",
                "audio_book": "",
                "adult_content": false,
                "content_type": "audio",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBLQT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--4a41f24607d67de7b1449b25d16a8d5e0ccebf1b/1.png?disposition=attachment",
                "created_at": "2020-02-27T15:28:23.872Z",
                "expiry_date": "2520-02-27T15:28:23.861Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:35:19.690Z",
                "duration": "10 days",
                "material": {
                    "material_id": 20,
                    "material_text": "Dance"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:28:25.724Z",
                "duration_number": 10,
                "duration_units": "days",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 14,
                "user_id": 1,
                "out_line": "Sample data 14",
                "description": "Sample data 14",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/bf316ebb-534f-438a-9c74-cf5a1877d299.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=0208d120713f6f2962495d8767256ca928673e8f7abcf11aff77a3008451d6b4",
                "audio_book": "",
                "adult_content": false,
                "content_type": "audio",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBLZz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dd926484a1714153cef58ce9c13db9179594224b/4.png?disposition=attachment",
                "created_at": "2020-02-27T15:33:44.523Z",
                "expiry_date": "2520-02-27T15:33:44.515Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:38:36.139Z",
                "duration": "5 weeks",
                "material": {
                    "material_id": 19,
                    "material_text": "Country"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:33:45.865Z",
                "duration_number": 5,
                "duration_units": "weeks",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 15,
                "user_id": 6,
                "out_line": "Sample Data 15",
                "description": "Sample Data 15",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/4e79fdfc-6559-4d24-86d5-fe0e3c21bf4a.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=7bf3554f636ba770b0df7dabd7359905a652aad82371dba4afc187c5a3a37db8",
                "audio_book": "",
                "adult_content": false,
                "content_type": "audio",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBMQT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--6e8c7cd060a22893cff92003859113a4ec72a730/3.png?disposition=attachment",
                "created_at": "2020-02-27T15:34:09.064Z",
                "expiry_date": "2520-02-27T15:34:09.055Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:35:24.559Z",
                "duration": "2 months",
                "material": {
                    "material_id": 19,
                    "material_text": "Country"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:34:10.758Z",
                "duration_number": 2,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            }
        ],
        "video": [
            {
                "id": 6,
                "user_id": 1,
                "out_line": "Sample Data6",
                "description": "Sample Data6",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/11798b0f-08b5-4c36-89db-2de0c9760a65.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=50e825eeb94edeb15533e871c56b489c0b7398d88b5dcd282491c7393c538afa",
                "audio_book": "",
                "adult_content": false,
                "content_type": "video",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBGUT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--795ff179390412bf2c6d7772f80d7d6111fcb7df/4.png?disposition=attachment",
                "created_at": "2020-02-27T14:56:22.052Z",
                "expiry_date": "2520-02-27T14:56:22.042Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T14:58:12.246Z",
                "duration": "15 weeks",
                "material": {
                    "material_id": 11,
                    "material_text": "Informational"
                },
                "links_cloud": {
                    "thumbnail": "https://d1kmg3lzyl3355.cloudfront.net/6e096c22-dbf3-42a9-8c3a-db44a095b899/thumbnails/11798b0f-08b5-4c36-89db-2de0c9760a65_tumb.0000006.jpg",
                    "video_url": {
                        "hls": "https://d1kmg3lzyl3355.cloudfront.net/6e096c22-dbf3-42a9-8c3a-db44a095b899/hls/11798b0f-08b5-4c36-89db-2de0c9760a65.m3u8",
                        "mp4": "https://d1kmg3lzyl3355.cloudfront.net/6e096c22-dbf3-42a9-8c3a-db44a095b899/mp4/11798b0f-08b5-4c36-89db-2de0c9760a65_Mp4_Avc_Aac_16x9_1920x1080p_24Hz_6Mbps_qvbr.mp4"
                    }
                },
                "updated_at": "2020-02-27T14:56:24.228Z",
                "duration_number": 15,
                "duration_units": "weeks",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 7,
                "user_id": 6,
                "out_line": "Sample Data7",
                "description": "Sample Data7",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/49e189ec-faa1-4ecd-a4ae-55b5e1577132.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=dc5d55a8cfb532c6d23077f564e22ba51fcbb1399dda7c9d43b98674c551902f",
                "audio_book": "",
                "adult_content": false,
                "content_type": "video",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBIQT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--d06f417217c7a1af6509b7db162b54c06dac7eb5/3.png?disposition=attachment",
                "created_at": "2020-02-27T15:04:06.635Z",
                "expiry_date": "2520-02-27T15:04:06.625Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:06:50.849Z",
                "duration": "10 days",
                "material": {
                    "material_id": 9,
                    "material_text": "Educational"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:04:08.584Z",
                "duration_number": 10,
                "duration_units": "days",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 12,
                "user_id": 6,
                "out_line": "Sample Data 10",
                "description": "Sample Data 10",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/3599bb71-cc8a-4555-84f0-17ebbeb2c4b5.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=b4c4acdc07ce7a55457b2ba33ea55bcf10218cb986b02ea67a0083ef5a9c72f6",
                "audio_book": "",
                "adult_content": false,
                "content_type": "video",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBKZz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--d4581a60cd8be5cf156a15ae9746da1d267cf42c/6.png?disposition=attachment",
                "created_at": "2020-02-27T15:27:09.357Z",
                "expiry_date": "2520-02-27T15:27:09.348Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:35:42.473Z",
                "duration": "10 days",
                "material": {
                    "material_id": 10,
                    "material_text": "Promotional"
                },
                "links_cloud": {
                    "thumbnail": "https://d1kmg3lzyl3355.cloudfront.net/5b7cb157-2c27-4b7e-a801-2a33f7980056/thumbnails/3599bb71-cc8a-4555-84f0-17ebbeb2c4b5_tumb.0000006.jpg",
                    "video_url": {
                        "hls": "https://d1kmg3lzyl3355.cloudfront.net/5b7cb157-2c27-4b7e-a801-2a33f7980056/hls/3599bb71-cc8a-4555-84f0-17ebbeb2c4b5.m3u8",
                        "mp4": "https://d1kmg3lzyl3355.cloudfront.net/5b7cb157-2c27-4b7e-a801-2a33f7980056/mp4/3599bb71-cc8a-4555-84f0-17ebbeb2c4b5_Mp4_Avc_Aac_16x9_1920x1080p_24Hz_6Mbps_qvbr.mp4"
                    }
                },
                "updated_at": "2020-02-27T15:27:10.994Z",
                "duration_number": 10,
                "duration_units": "days",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 11,
                "user_id": 6,
                "out_line": "Sample Data 11",
                "description": "Sample Data 11",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/2945f5bb-0e05-401e-9b71-96a30a4394de.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=1799346870356af2fe0770702dc172c97cf69f894a72241436788dcbbd66106f",
                "audio_book": "",
                "adult_content": false,
                "content_type": "video",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBKQT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a09a9ac049d46793c6c5d79c4acb0aa9d1b12baa/5.png?disposition=attachment",
                "created_at": "2020-02-27T15:25:41.542Z",
                "expiry_date": "2520-02-27T15:25:41.528Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:36:36.817Z",
                "duration": "10 months",
                "material": {
                    "material_id": 10,
                    "material_text": "Promotional"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:25:43.894Z",
                "duration_number": 10,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 10,
                "user_id": 6,
                "out_line": "Sample Data 12",
                "description": "Sample Data 12",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/5e6c4300-2340-47d5-8525-e2b147be4477.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=72457c87229535632363899313c77a1072f36119328c55ff68ccdc9eab935d3b",
                "audio_book": "",
                "adult_content": false,
                "content_type": "video",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBMZz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--61fb3908ee470b936b2934a6123447af6f6309b1/2.png?disposition=attachment",
                "created_at": "2020-02-27T15:23:59.852Z",
                "expiry_date": "2520-02-27T15:23:59.840Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:36:32.058Z",
                "duration": "10 days",
                "material": {
                    "material_id": 10,
                    "material_text": "Promotional"
                },
                "links_cloud": {
                    "thumbnail": "https://d1kmg3lzyl3355.cloudfront.net/a35546b6-2b35-44d1-83e5-822c23301225/thumbnails/5e6c4300-2340-47d5-8525-e2b147be4477_tumb.0000006.jpg",
                    "video_url": {
                        "hls": "https://d1kmg3lzyl3355.cloudfront.net/a35546b6-2b35-44d1-83e5-822c23301225/hls/5e6c4300-2340-47d5-8525-e2b147be4477.m3u8",
                        "mp4": "https://d1kmg3lzyl3355.cloudfront.net/a35546b6-2b35-44d1-83e5-822c23301225/mp4/5e6c4300-2340-47d5-8525-e2b147be4477_Mp4_Avc_Aac_16x9_1920x1080p_24Hz_6Mbps_qvbr.mp4"
                    }
                },
                "updated_at": "2020-02-27T15:36:28.187Z",
                "duration_number": 10,
                "duration_units": "days",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            }
        ],
        "document": [
            {
                "id": 1,
                "user_id": 1,
                "out_line": "Sample Data",
                "description": "Sample Data",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/7cac5bb3-72a3-4e45-9802-ccd8bb50a3ed.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=b71958a0276e5b6f92062561a0e6980748c98146da227cfda4deb0891e5770e6",
                "audio_book": "",
                "adult_content": false,
                "content_type": "document",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBDUT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--4d75e60c2fcbc1fa7a5725aec60eb2911b324b3e/3.png?disposition=attachment",
                "created_at": "2020-02-27T14:30:40.188Z",
                "expiry_date": "2520-02-27T14:30:40.165Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:35:34.739Z",
                "duration": "2 months",
                "material": {
                    "material_id": 1,
                    "material_text": "Books"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T14:30:42.352Z",
                "duration_number": 2,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 2,
                "user_id": 1,
                "out_line": "Sample Data2",
                "description": "Sample Data",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/3bbd2ad2-63d2-450f-977a-96fa4e44db97.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=e0528777fa471ea40b83feb1904bc070a017bbee499e7087aa547663736c08a8",
                "audio_book": "",
                "adult_content": false,
                "content_type": "document",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBDdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--5fa2e0eeafd5e06ed10c384babb8c3808c2623c4/6.png?disposition=attachment",
                "created_at": "2020-02-27T14:33:55.791Z",
                "expiry_date": "2520-02-27T14:33:55.779Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T14:57:30.643Z",
                "duration": "1 month",
                "material": {
                    "material_id": 3,
                    "material_text": "Magazines"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T14:33:57.121Z",
                "duration_number": 1,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 3,
                "user_id": 1,
                "out_line": "Sample Data3",
                "description": "Sample Data3",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/1/content/9ddcb628-2d66-4c7e-bf4a-9fd5cb5478b3.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=86d45b38dbbcb1a0c526afb69e4639fd0202399de566686798cc02181a9ff836",
                "audio_book": "",
                "adult_content": false,
                "content_type": "document",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEUT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--3180654aa48b6c799eb2bbf52abaeece68373cf8/1.png?disposition=attachment",
                "created_at": "2020-02-27T14:38:17.091Z",
                "expiry_date": "2520-02-27T14:38:17.074Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T14:57:07.039Z",
                "duration": "10 weeks",
                "material": {
                    "material_id": 5,
                    "material_text": "Newsletters"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T14:38:18.704Z",
                "duration_number": 10,
                "duration_units": "weeks",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 1,
                    "name": "Juliana",
                    "email": "juliana@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 2,
                    "sign_in_count": 563,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBCdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a84b0f466154d146662baffc7eba86adc6cd8375/images.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 2,
                        "status": "active",
                        "expires_on": "2021-02-27T14:20:49.581Z",
                        "user_id": 1,
                        "plan_id": 1,
                        "remaining_space": 155248,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "152 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 49552,
                        "friendly_used_space": "48.4 MB",
                        "used_space_percentage": 24.1953125,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Journalist",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 8,
                "user_id": 6,
                "out_line": "Sample Data 8",
                "description": "Sample Data 8",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/0a5d6b8a-6c91-4d98-99ae-e92e058eff7b.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=1ddf2ab5191681c81d8efbf6150e9054ce122cadcbde67772d5e2268be0e09f5",
                "audio_book": "",
                "adult_content": false,
                "content_type": "document",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBIZz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--189c2464889b879e62738d8e6b050f17113d3bf5/4.png?disposition=attachment",
                "created_at": "2020-02-27T15:20:37.768Z",
                "expiry_date": "2520-02-27T15:20:37.758Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:36:55.786Z",
                "duration": "2 months",
                "material": {
                    "material_id": 6,
                    "material_text": "Albums"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:20:39.608Z",
                "duration_number": 2,
                "duration_units": "months",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            },
            {
                "id": 9,
                "user_id": 6,
                "out_line": "Sample Data9",
                "description": "Sample Data9",
                "is_downloadable": false,
                "link": "https://scriptdoor-video-source-ni8cs9ho9jt1.s3-accelerate.amazonaws.com/users/6/content/f8cba83a-0bf4-4d74-bf13-4b9dc9aa48dc.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATFR5C3SYEWOC47DB%2F20200228%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20200228T162340Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=d7b5851eccdd77c02b82f431497ebf25beb76b14126a55f15d9f3cb453e576a7",
                "audio_book": "",
                "adult_content": false,
                "content_type": "document",
                "thumb": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBJQT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--a4b2d547038b7ca9df3e74edbf17462f3d8d0489/2.png?disposition=attachment",
                "created_at": "2020-02-27T15:21:57.000Z",
                "expiry_date": "2520-02-27T15:21:56.986Z",
                "tokens": 0,
                "age_limit": null,
                "category_type": null,
                "content_relationship": null,
                "published_at": null,
                "creator_published_at": "2020-02-27T15:36:46.409Z",
                "duration": "10 days",
                "material": {
                    "material_id": 6,
                    "material_text": "Albums"
                },
                "links_cloud": null,
                "updated_at": "2020-02-27T15:21:58.922Z",
                "duration_number": 10,
                "duration_units": "days",
                "creator_library_type": "public",
                "collection_type": "content",
                "user": {
                    "id": 6,
                    "name": "alexa",
                    "email": "alexa@yopmail.com",
                    "phone": null,
                    "birth_date": "2002-02-19",
                    "status": "public_profile",
                    "is_private": false,
                    "user_type": "individual",
                    "user_account_type": "owner",
                    "user_category_id": 6,
                    "sign_in_count": 481,
                    "about": null,
                    "is_active": true,
                    "locations": {
                        "id": null,
                        "country": null,
                        "state": null,
                        "city": null,
                        "latitude": null,
                        "longitude": null,
                        "zip_code": null
                    },
                    "avatar": "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBEdz09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dfe8de07843b8ab1e4fbba9d442e57ff24087c49/test12.jpg?disposition=attachment",
                    "cover": "",
                    "subscription": {
                        "id": 5,
                        "status": "active",
                        "expires_on": "2021-02-27T14:42:13.807Z",
                        "user_id": 6,
                        "plan_id": 1,
                        "remaining_space": 135443,
                        "total_space": 204800,
                        "no_of_days_remaining": 365,
                        "friendly_remaining_space": "132 MB",
                        "friendly_total_space": "200 MB",
                        "used_space": 69357,
                        "friendly_used_space": "67.7 MB",
                        "used_space_percentage": 33.86572265625,
                        "plan": {
                            "id": 1,
                            "name": "Free - Registration",
                            "price": 0,
                            "created_at": "2020-02-27T14:07:11.626Z",
                            "updated_at": "2020-02-27T14:07:11.626Z",
                            "is_active": true,
                            "duration": 12,
                            "total_space": 200,
                            "is_sell_material": false,
                            "create_own_content": true,
                            "sales_commission": 0,
                            "can_buy_content": true,
                            "has_analytics": false,
                            "no_ads": false,
                            "user_type": "individual",
                            "has_premium_templates": false,
                            "add_ons_allowed": false,
                            "manage_own_ads": false,
                            "has_redistribution_system": false,
                            "additional_libraries_allowed": false,
                            "space_unit": "MB"
                        }
                    },
                    "connection_status": "",
                    "connection_id": 0,
                    "can_send_request": true,
                    "category": "Film producer",
                    "ico": null,
                    "blocked": false,
                    "private_message": null
                },
                "material_advertisement": null
            }
        ]
    },
    "status": 200,
    "meta": {},
    "errors": ""
  }
}
